const common = {
  home: "Home",
  shoppingGuide: "Shopping Guide",
  allCategories: "All Categories",
  buyNow: "Buy It Now",
};

export default common;